import { SanitizationOption } from 'app/utils/htmlSanitizer/types';
import { dataUserIdAttribute } from 'components/editorMentions';

import { removeModalLikeStyles } from '../utils';

import { SANITIZE_PROFILE_DEFAULT } from './default';

export const SANITIZE_PROFILE_EMAIL: SanitizationOption = {
  allowedTags: [
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'b',
    'bdo',
    'big',
    'blockquote',
    'br',
    'button',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'dd',
    'del',
    'dfn',
    'dir',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'font',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'map',
    'mark',
    'menu',
    'ol',
    'optgroup',
    'option',
    'p',
    'pre',
    'q',
    's',
    'samp',
    'select',
    'small',
    'span',
    'strike',
    'strong',
    'sub',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'tr',
    'tt',
    'u',
    'ul',
    'var',
  ],
  allowedAttributes: {
    '*': [
      'style',
      'width',
      'height',
      'id',
      'class',
      'lang',
      'tabindex',
      'title',
      'dir',
      'color',
      'align',
      'bgcolor',
    ],
    area: ['shape', 'coords', 'href', 'target', 'alt', 'download'],
    bdo: ['fir'],
    blockquote: ['cite'],
    del: ['cite', 'datetime'],
    fieldset: ['disabled', 'form', 'name'],
    hr: ['color', 'noshade', 'size'],
    input: [
      'type',
      'disabled',
      'alt',
      'checked',
      'max',
      'min',
      'placeholder',
      'inputmode',
      'readonly',
      'required',
      'value',
      'pattern',
    ],
    ins: ['cite', 'datetime'],
    label: ['for', 'form'],
    li: ['value', 'type'],
    map: ['name'],
    menu: ['label', 'type'],
    ol: ['reversed', 'start', 'type'],
    optgroup: ['label', 'disabled'],
    option: ['value', 'label', 'selected'],
    q: ['cite'],
    select: ['disabled', 'name', 'required', 'size', 'multiple'],
    span: [dataUserIdAttribute],
    table: [
      'border',
      'cellpadding',
      'cellspacing',
      'frame',
      'rules',
      'summary',
    ],
    tbody: ['char', 'charoff', 'valign'],
    td: [
      'abbr',
      'axis',
      'char',
      'charoff',
      'colspan',
      'headers',
      'rowspan',
      'scope',
      'valign',
    ],
    textarea: [
      'autocapitalize',
      'cols',
      'disabled',
      'maxlength',
      'minlength',
      'name',
      'placeholder',
      'readonly',
      'required',
      'rows',
      'spellcheck',
      'wrap',
    ],
    tfoot: ['char', 'charoff', 'valign'],
    th: [
      'abbr',
      'axis',
      'char',
      'charoff',
      'valign',
      'colspan',
      'headers',
      'rowspan',
      'scope',
      'valign',
    ],
    thead: ['char', 'charoff', 'valign'],
    tr: ['char', 'charoff', 'valign'],
    ul: ['compact', 'type'],
    a: ['href', 'download', 'rel', 'hreflang', 'target'],
    img: ['src', 'alt', 'usemap'],
  },
  allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
  // Remove any modals that might block the UI, since outbound messages aren't wrapped in an iframe/shadow root
  exclusiveFilter: (element) =>
    element.tag === 'div' && element.attribs['id'] === 'modal-container',
  transformTags: {
    '*': removeModalLikeStyles,
  },
};
